/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const isCMDBEnabledInEnvironment = (): boolean => true;
